import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import Topbar from '../components/layout/Topbar';
import { Panel, PanelHead, PanelBody, Input, Button, Spinner } from '../components/ui';
import { updateBeach } from '../services/firebase';

export default function Settings() {
  const { beach, admin, refreshBeach } = useAuth();
  const [saving, setSaving]   = useState(false);
  const [saved, setSaved]     = useState(false);

  const [form, setForm] = useState({
    nome:      beach?.nome      || '',
    indirizzo: beach?.indirizzo || '',
    telefono:  beach?.telefono  || '',
    email:     beach?.email     || '',
    sabbia:    beach?.sabbia    || '',
    lun_ven:   beach?.orari_apertura?.lun_ven || '',
    sab_dom:   beach?.orari_apertura?.sab_dom || '',
  });

  const set = (f) => (e) => setForm((p) => ({ ...p, [f]: e.target.value }));

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateBeach(admin.beachCode, {
        nome: form.nome,
        indirizzo: form.indirizzo,
        telefono: form.telefono,
        email: form.email,
        sabbia: form.sabbia,
        orari_apertura: { lun_ven: form.lun_ven, sab_dom: form.sab_dom },
      });
      await refreshBeach();
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Topbar
        title="Impostazioni lido"
        actions={
          <Button variant={saved ? 'ghost' : 'primary'} onClick={handleSave} disabled={saving}>
            {saving ? <Spinner size={14} /> : saved ? '✓ Salvato' : 'Salva modifiche'}
          </Button>
        }
      />

      <div style={{ padding: '24px 28px', overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Panel>
          <PanelHead title="Informazioni generali" />
          <PanelBody>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
              <div style={{ gridColumn: 'span 2' }}>
                <Input label="Nome stabilimento" value={form.nome} onChange={set('nome')} placeholder="Lido Le Dune" />
              </div>
              <div style={{ gridColumn: 'span 2' }}>
                <Input label="Indirizzo" value={form.indirizzo} onChange={set('indirizzo')} placeholder="Via delle Dune, 15, Avola (SR)" />
              </div>
              <Input label="Telefono" type="tel" value={form.telefono} onChange={set('telefono')} placeholder="+39 0931 112233" />
              <Input label="Email pubblica" type="email" value={form.email} onChange={set('email')} placeholder="info@tuolido.it" />
            </div>
          </PanelBody>
        </Panel>

        <Panel>
          <PanelHead title="Caratteristiche" />
          <PanelBody>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px' }}>
              <div>
                <label style={{ fontSize: '12px', color: 'var(--text-muted)', display: 'block', marginBottom: '6px' }}>
                  Tipo di sabbia
                </label>
                <select
                  value={form.sabbia}
                  onChange={set('sabbia')}
                  style={{
                    width: '100%', background: 'var(--surface)', border: '1px solid var(--border-mid)',
                    borderRadius: 'var(--radius-md)', color: '#fff', padding: '9px 12px',
                    fontSize: '13.5px', fontFamily: 'var(--font-sans)',
                  }}
                >
                  <option value="">Seleziona...</option>
                  <option value="sabbia">Sabbia</option>
                  <option value="ciottoli">Ciottoli</option>
                  <option value="misto">Misto</option>
                  <option value="scogliera">Scogliera</option>
                </select>
              </div>
              <Input label="Orari Lun-Ven" value={form.lun_ven} onChange={set('lun_ven')} placeholder="08:30 - 19:30" />
              <Input label="Orari Sab-Dom" value={form.sab_dom} onChange={set('sab_dom')} placeholder="07:30 - 20:00" />
            </div>
          </PanelBody>
        </Panel>

        <Panel>
          <PanelHead title="Codice lido" subtitle="Usato internamente per collegare prenotazioni e disponibilità" />
          <PanelBody>
            <div style={{
              fontFamily: 'monospace', fontSize: '13px',
              color: 'var(--ocean)', background: 'var(--surface)',
              padding: '10px 14px', borderRadius: 'var(--radius-md)',
              border: '1px solid var(--border)',
            }}>
              {admin?.beachCode || '—'}
            </div>
          </PanelBody>
        </Panel>
      </div>
    </div>
  );
}
